module.exports = __webpack_public_path__ + "img/track-results.202b29a6.svg";